import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  exhaustMap,
  filter,
  map,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { GeneralAdapter } from '../../adapters/general.adapter';
import { loadDeclineReasons, loadDeclineReasonsFailure, loadDeclineReasonsSuccess } from './decline-reasons.actions';
import { selectDeclineReasonsTotal } from './decline-reasons.reducer';

@Injectable()
export class DeclineReasonsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly generalAdapter = inject(GeneralAdapter);

  loadDeclineReasons$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDeclineReasons),
      withLatestFrom(this.store.select(selectDeclineReasonsTotal)),
      filter(([, total]) => total === 0),
      exhaustMap(() =>
        this.generalAdapter.getDeclineReasons().pipe(
          map((declineReasons) => loadDeclineReasonsSuccess({ declineReasons })),
          catchError((error) => {
            return of(loadDeclineReasonsFailure({ error }));
          }),
        ),
      ),
    ),
  );

  loadDeclineReasonsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadDeclineReasonsFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
